import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  "NAME": (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};

const getQuizDuck = createDuck('GET_QUIZ', newActions, newReducers);

const getQuizThunk = (quizId) => {
 
  const url = `${baseUrl}/quiz/${quizId}`;
  return createThunk(axios, 'get', getQuizDuck.actions, url, null);
};

const getQuizzesDuck = createDuck("CREAR_QUIZ", newActions, newReducers);

const getQuizzesThunk = (token, page, limit) => {

  const data = {
    token, page, limit
  };

  const url = `${baseUrl}/getQuizzes/`;
  return createThunk(axios, "post", getQuizzesDuck.actions, url, data);
};

const crearQuizDuck = createDuck("CREAR_QUIZ", newActions, newReducers);

const crearQuizThunk = (data) => {
  const url = `${baseUrl}/quiz/`;
  return createThunk(axios, "post", crearQuizDuck.actions, url, data);
};

const editarQuizDuck = createDuck("EDITAR_QUIZ", newActions, newReducers);

const editarQuizThunk = (data) => {
  const url = `${baseUrl}/quiz/`;
  return createThunk(axios, "patch", editarQuizDuck.actions, url, data);
};

const addQuizOpcionDuck = createDuck("ADD_QUIZ_OPCION", newActions, newReducers);

const addQuizOpcionThunk = (data) => {
  const url = `${baseUrl}/quiz/opcion`;
  return createThunk(axios, "post", addQuizOpcionDuck.actions, url, data);
};

const editQuizOpcionDuck = createDuck("EDIT_QUIZ_OPCION", newActions, newReducers);

const editQuizOpcionThunk = (data) => {

  const url = `${baseUrl}/quiz/opcion`;
  return createThunk(axios, "patch", editQuizOpcionDuck.actions, url, data);
};

const duckEliminarImgQuizOpcion = createDuck("ELIMINAR_IMG_OPCION");

const eliminarImgQuizOpcionThunk = (data) => {
  const url = `${baseUrl}/eliminarImgOpcion`;
  return createThunk(axios, "post", duckEliminarImgQuizOpcion.actions, url, data);
};

export default {
  crearQuizDuck,
  crearQuizThunk,
  getQuizDuck,
  getQuizThunk,
  editarQuizDuck,
  editarQuizThunk,
  getQuizzesDuck,
  getQuizzesThunk,
  addQuizOpcionDuck,
  addQuizOpcionThunk,
  editQuizOpcionDuck,
  editQuizOpcionThunk,
  duckEliminarImgQuizOpcion,
  eliminarImgQuizOpcionThunk,
};
